import React from "react";
import {
  List,
  Datagrid,
  TextField,
  Create,
  TextInput,
  Edit,
  EditButton,
  Delete,
  Filter,
  TabbedForm,
  FormTab,
  DateInput,
  DateField,
  SelectInput,
  ReferenceInput,
  ReferenceField
} from "admin-on-rest/lib/mui";

import { Actions } from "../../custom/actions";
import Gallery from "../custom/gallery_news";
import RichTextInput from "aor-rich-text-input";
import { RichTextField, required } from "admin-on-rest";
import CustomImageField from "../custom/imageSize";
import SubGenreInput from "../custom/SubGenreInput";
import { DependentInput } from "aor-dependent-input";

export const BoatFilter = props => (
  <Filter {...props}>
    <ReferenceInput
      label="resources.branches.name"
      source="BranchID"
      reference="branches"
      allowEmpty
      alwaysOn
      perPage={1000}
    >
      <SelectInput
        optionText={choice => `${choice.tmima + " " + choice.address}`}
      />
    </ReferenceInput>
  </Filter>
);

const dateFormatter = v => {
  // v is a string of "YYYY-MM-DD" format
  const match = /(\d{4})-(\d{2})-(\d{2})/.exec(v);
  if (match === null) return;
  console.log("match", match);
  var day = parseInt(match[3], 10) + 1;
  const d = new Date(match[1], parseInt(match[2], 10) - 1, day);
  console.log("d", d);
  if (isNaN(d)) return;
  return d;
};

export const NewsList = props => (
  <List
    {...props}
    actions={<Actions />}
    filters={<BoatFilter />}
    title="resources.management_offers.name"
  >
    <Datagrid key={props._id}>
      <CustomImageField
        width={200}
        height={125}
        source="gallery[0]"
        label="εικονα"
      />
      <TextField label="resources.title.name" source="title" />
      <RichTextField label="resources.description.name" source="description" />
      <DateField
        label="resources.expiration_date.name"
        source="date"
        showTime
      />
      <ReferenceField
        label="resources.branches.name"
        source="BranchID"
        reference="branches"
      >
        <TextField source="tmima_address" />
      </ReferenceField>
      <EditButton />
    </Datagrid>
  </List>
);

const userType = localStorage.getItem("permissions");

export const CreateNew = props => (
  <Create {...props}>
    <TabbedForm redirect="list">
      <FormTab label="general">
        <TextInput
          label="resources.title.name"
          source="title"
          validate={required}
        />
        <RichTextInput
          label="resources.description.name"
          source="description"
          validate={required}
        />
        <DateInput
          label="resources.expiration_date.name"
          source="date"
          format={dateFormatter}
        />
        {userType === 'SuperUser' &&
          <ReferenceInput
            label="resources.companies.name"
            source="CompanyID"
            reference="companies"
            allowEmpty
          >
            <SelectInput optionText={choice => `${choice.name}`} />
          </ReferenceInput>}

        {
          //  <DependentInput dependsOn="CompanyID" >
          //  <TextField label="Υποκατάστημα" />
          //  <SubGenreInput />
          // </DependentInput>
        }
        <ReferenceInput
          label="resources.branches.name"
          source="BranchID"
          reference="branches"
          allowEmpty
          alwaysOn
          perPage={1000}
        >
          <SelectInput
            optionText={choice => `${choice.tmima + " " + choice.address}`}
          />
        </ReferenceInput>
      </FormTab>
      <FormTab label="photos">
        <Gallery source="gallery" />
      </FormTab>
    </TabbedForm>
  </Create>
);

const PostTitle = ({ record }) => {
  return <span>{record ? `${record.title}` : ""}</span>;
};

export const EditNew = props => (
  <Edit title={<PostTitle />} {...props}>
    <TabbedForm>
      <FormTab label="general">
        <TextInput
          label="resources.title.name"
          source="title"
          validate={required}
        />
        <RichTextInput
          label="resources.description.name"
          source="description"
          validate={required}
        />
        <DateInput
          label="resources.expiration_date.name"
          source="date"
          format={dateFormatter}
        />
        <ReferenceInput
          label="resources.companies.name"
          source="CompanyID"
          reference="companies"
          allowEmpty
        >
          <SelectInput optionText={choice => `${choice.name}`} />
        </ReferenceInput>
        <DependentInput dependsOn="CompanyID">
          <TextField label="resources.branches.name" />
          <SubGenreInput />
        </DependentInput>
      </FormTab>
      <FormTab label="photos">
        <Gallery source="gallery" />
      </FormTab>
    </TabbedForm>
  </Edit>
);

const DeleteTitle = ({ record }) => {
  return <span>{record ? `Διαγραφή του ${record.title}` : ""}</span>;
};

export const DeleteNew = props => <Delete title={<DeleteTitle />} {...props} />;



// WEBPACK FOOTER //
// ./src/pages/companies/news.js